<template>
  <div>
    <!-- Name -->
    <div v-if="show.name" class="mt-u6">
      <label ref="label__name" for="input__name" class="mb-u2"> Name </label>
      <b-form-input
        id="input__name"
        ref="input__name"
        v-model="form.firstname"
        class="input__name"
        placeholder="Enter your name"
        :disabled="disabled"
      />
    </div>

    <!-- Surname -->
    <div v-if="show.surname" class="mt-u6">
      <label ref="label__surname" for="input__surname" class="mb-u2"> Surname </label>
      <b-form-input
        id="input__surname"
        ref="input__surname"
        v-model="form.lastname"
        class="input__surname"
        placeholder="Enter your surname"
        :disabled="disabled"
      />
    </div>

    <!-- Date of birth -->
    <div v-if="show.dateOfBirth" class="mt-u6">
      <label ref="label__date-of-birth" for="input__date-of-birth" class="mb-u2">
        Date of birth</label
      >
      <BaseDatePicker
        ref="input__date-of-birth"
        :existed-data="form.date_of_birth"
        :show="{ date: true, time: false }"
        date-picker-class="w-100"
        @emitDate="
          (date) => {
            form.date_of_birth = date;
          }
        "
      />
    </div>

    <!-- Age -->
    <div v-if="show.age" class="mt-u6">
      <label ref="label__age" for="input__age" class="mb-u2">Age</label>
      <b-form-select
        id="input__age"
        ref="input__age"
        v-model="form.age"
        class="input__age"
        :options="ageOptions"
        :disabled="disabled"
        value-field="value"
        text-field="name"
      >
        <template #first>
          <b-form-select-option :value="null" disabled> Select an age range </b-form-select-option>
        </template>
      </b-form-select>
    </div>

    <!-- country -->
    <div v-if="show.country" class="mt-u6">
      <label ref="label__country" for="input__country" class="mb-u2"
        >Please select your country</label
      >
      <b-form-select
        id="input__country"
        ref="input__country"
        v-model="form.country"
        class="input__country"
        :options="countryOptions"
        :disabled="disabled"
        value-field="value"
        text-field="name"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            Please select your country
          </b-form-select-option>
        </template>
      </b-form-select>
    </div>

    <!-- Mobile phone number -->
    <div v-if="show.phoneNumber" class="mt-u6">
      <label ref="label__phone-number" for="input__phone-number" class="mb-u2">
        Mobile phone number (Optional)
      </label>
      <b-form-input
        id="mobliePhoneNumber-number"
        ref="input__phone-number"
        v-model="form.phone_number"
        type="text"
        autocomplete="off"
        class="input__phone-number"
        placeholder="Enter your mobile phone number"
        :disabled="disabled"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        :state="$v.form.phone_number.$anyError ? false : null"
      />
      <b-form-invalid-feedback
        v-if="!$v.form.phone_number.numeric"
        id="mobliePhoneNumber-invalid-feedback"
        ref="error__phone-number"
      >
        Mobile phone number is invalid.
      </b-form-invalid-feedback>

      <b-form-invalid-feedback
        v-else-if="!$v.form.phone_number.length"
        id="mobliePhoneNumber-invalid-feedback"
        ref="error__phone-number"
      >
        Mobile phone number should be 10 digits.
      </b-form-invalid-feedback>
    </div>

    <!-- Email -->
    <div v-if="show.email" class="mt-u6">
      <label ref="label__email" for="input__email" class="mb-u2"> Email </label>
      <b-form-input
        id="input__email"
        ref="input__email"
        v-model="data.email"
        class="input__email"
        :disabled="true"
      />
    </div>

    <!-- Current occupation -->
    <div v-if="show.currentOccupation" class="mt-u6">
      <label ref="label__current-occupation" for="input__current-occupation" class="mb-u2">
        Current occupation
      </label>
      <b-form-select
        id="input__current-occupation"
        ref="input__current-occupation"
        v-model="form.current_occupation"
        class="input__current-occupation"
        :options="currentOccupations"
        :disabled="disabled"
        value-field="value"
        text-field="name"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            Select your current occupation
          </b-form-select-option>
        </template>
        <b-form-select-option value="Other">Other</b-form-select-option>
      </b-form-select>

      <div v-if="form.current_occupation === 'Other'" class="mt-u6 ml-u4">
        <label
          ref="label__current-occupation-other"
          for="input__current-occupation-other"
          class="mb-u2"
        >
          Other
        </label>
        <b-form-input
          ref="currentOccupationOther"
          v-model="currentOccupationOther"
          :state="$v.currentOccupationOther.$anyError ? false : null"
        />

        <b-form-invalid-feedback
          v-if="!$v.currentOccupationOther.required"
          id="currentOccupationOther-invalid-feedback"
        >
          Please tell us what is your current occupation.
        </b-form-invalid-feedback>
      </div>
    </div>

    <div v-if="show.company" class="mt-u6">
      <label ref="label__company" for="input__company" class="mb-u2"> Company </label>
      <b-form-input
        id="input__company"
        ref="input__company"
        v-model="form.company"
        class="input__company"
        placeholder="Enter your company"
        :disabled="disabled"
      />
    </div>

    <!-- Interested occupation -->
    <div v-if="show.desiredOccupation" class="mt-u6">
      <label ref="label__desired-occupation" for="input__desired-occupation" class="mb-u2">
        Interested occupation
      </label>
      <b-form-select
        id="input__desired-occupation"
        ref="input__desired-occupation"
        v-model="form.desired_occupation"
        class="input__desired-occupation"
        :options="desiredOccupations"
        :disabled="disabled"
        value-field="value"
        text-field="name"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            Select your Interested occupation
          </b-form-select-option>
        </template>
        <b-form-select-option value="Other">Other</b-form-select-option>
      </b-form-select>

      <div v-if="form.desired_occupation === 'Other'" class="mt-u6 ml-u4">
        <label
          ref="label__desired_occupation-other"
          for="input__desired_occupation-other"
          class="mb-u2"
        >
          Other
        </label>
        <b-form-input
          ref="desiredOccupationOther"
          v-model="desiredOccupationOther"
          :state="$v.desiredOccupationOther.$anyError ? false : null"
        />

        <b-form-invalid-feedback
          v-if="!$v.desiredOccupationOther.required"
          id="desiredOccupationOther-invalid-feedback"
        >
          Please tell us what is your Interested occupation.
        </b-form-invalid-feedback>
      </div>
    </div>

    <!-- Area of employment -->
    <div v-if="show.areaOfEmployment" class="mt-u6">
      <label ref="label__area-of-employment" for="input__area-of-employment" class="mb-u2">
        Area of employment
      </label>
      <b-form-select
        id="input__area-of-employment"
        ref="input__area-of-employment"
        v-model="form.area_of_employment"
        class="input__area-of-employment"
        :options="employmentAreas"
        :disabled="disabled"
        value-field="value"
        text-field="name"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            Select your area of employment
          </b-form-select-option>
        </template>
      </b-form-select>
    </div>

    <!-- Experience level -->
    <div v-if="show.experienceLevel" class="mt-u6">
      <label ref="label__experience-level" for="input__experience-level" class="mb-u2">
        Job level/ Job Position
      </label>
      <b-form-select
        id="input__experience-level"
        ref="input__experience-level"
        v-model="form.experience_level"
        class="input__experience-level"
        :options="experienceLevels"
        :disabled="disabled"
        value-field="value"
        text-field="name"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            Select your experience level
          </b-form-select-option>
        </template>
      </b-form-select>
    </div>

    <!-- Education level -->
    <div v-if="show.educationLevel" class="mt-u6">
      <label ref="label__education-level" for="input__education-level" class="mb-u2">
        What is your highest educational level currently?
      </label>
      <b-form-radio-group
        id="input__education-level"
        ref="input__education-level"
        v-model="form.education_level"
        stacked
        :disabled="disabled"
      >
        <b-form-radio value="Junior high school" class="mb-u4"> Junior high school </b-form-radio>
        <b-form-radio value="High school" class="mb-u4"> High school </b-form-radio>
        <b-form-radio value="Pre graduation" class="mb-u4"> Pre graduation </b-form-radio>
        <b-form-radio value="Graduated" class="mb-u4"> Graduated </b-form-radio>
        <b-form-radio value="Occupied" class="mb-u4"> Occupied </b-form-radio>
        <b-form-radio value="Other">
          <div class="d-flex">
            <div class="mr-u4">Other</div>

            <div>
              <b-form-input
                ref="educationLevelOther"
                v-model="educationLevelOther"
                :state="$v.educationLevelOther.$anyError ? false : null"
              />

              <b-form-invalid-feedback
                v-if="!$v.educationLevelOther.required"
                id="educationLevelOther-invalid-feedback"
              >
                Please tell us your highest educational level.
              </b-form-invalid-feedback>
            </div>
          </div>
        </b-form-radio>
      </b-form-radio-group>
    </div>

    <!-- Goals -->
    <div v-if="show.goals" class="mt-u6">
      <label ref="label__goals" for="input__goals" class="mb-u3">
        What is your goals?
        <div class="text-description mt-u1">Choose as many as you like</div>
      </label>
      <b-form-checkbox-group ref="input__goals" v-model="form.goals" :disabled="disabled" stacked>
        <b-form-checkbox class="mb-u4" value="Grow and advance in my current career">
          Grow and advance in my current career
        </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Transition into a new career">
          Transition into a new career
        </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="I'm learning for academic study">
          I'm learning for academic study
        </b-form-checkbox>
      </b-form-checkbox-group>
    </div>
    <!-- Like to learn -->
    <div v-if="show.likeToLearn" class="mt-u6">
      <label ref="label__like-to-learn" for="input__like-to-learn" class="mb-u2">
        How you like to learn?
        <div class="text-description mt-u1">Choose as many as you like</div>
      </label>
      <b-form-checkbox-group
        ref="input__like-to-learn"
        v-model="form.like_to_learn"
        :disabled="disabled"
        stacked
      >
        <b-form-checkbox class="mb-u4" value="Short courses">
          Short courses
          <div class="text-description mt-u2">
            1-4 weeks. Build new skills quickly over a few weeks
          </div>
        </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="ExpertTracks">
          ExpertTracks
          <div class="text-description mt-u2">
            6-21 weeks. Take a series of specialist courses in your own time
          </div>
        </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Microcredentials">
          Microcredentials
          <div class="text-description mt-u2">
            10-15 weeks. Earn accreditation with in-depth, career-focussed study
          </div>
        </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Online degrees">
          Online degrees
          <div class="text-description mt-u2">
            12+ weeks. Complete a full degree course flexibly, 100% online
          </div>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </div>

    <!-- Know us from? -->
    <div v-if="show.knowUsFrom" class="mt-u6">
      <label ref="label__know-us-from" for="input__know-us-from" class="mb-u3">
        How do you know us?
        <div class="text-description mt-u1">Choose as many as you like</div>
      </label>
      <b-form-checkbox-group
        ref="input__know-us-from"
        v-model="form.know_us_from"
        stacked
        :disabled="disabled"
      >
        <b-form-checkbox class="mb-u4" value="Website 4LifeLongLearning">
          Website 4LifeLongLearning
        </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Facebook 4LifeLongLearning">
          Facebook 4LifeLongLearning
        </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Facebook pages อื่นๆ">
          Facebook pages อื่นๆ
        </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Google"> Google </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Youtube"> Youtube </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Line"> Line </b-form-checkbox>
        <b-form-checkbox value="Other">
          <div class="d-flex">
            <div ref="label__know_us_from-other" class="mr-u4">Other</div>

            <div>
              <b-form-input
                ref="knowUsFromOther"
                v-model="knowUsFromOther"
                :state="$v.knowUsFromOther.$anyError ? false : null"
                :disabled="form.know_us_from.includes('Other') ? false : true"
              />

              <b-form-invalid-feedback
                v-if="!$v.knowUsFromOther.required"
                id="knowUsFromOther-invalid-feedback"
              >
                Please tell us how you know us.
              </b-form-invalid-feedback>
            </div>
          </div>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </div>

    <!-- Interesed Micro Credentail -->
    <div v-if="show.interests" class="mt-u6">
      <label
        ref="label__interested-micro-credential"
        for="input__interested-micro-credential"
        class="mb-u3"
      >
        What additional Micro-credentials categories are you interested?
        <div class="text-description mt-u1">Choose as many as you like</div>
      </label>
      <b-form-checkbox-group
        ref="input__interested-micro-credential"
        v-model="form.interested_micro_credentials"
        stacked
        :disabled="disabled"
      >
        <b-form-checkbox class="mb-u4" value="Business"> Business </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Technology"> Technology </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Education"> Education </b-form-checkbox>
        <b-form-checkbox class="mb-u4" value="Science & Technology">
          Science & Technology
        </b-form-checkbox>
        <b-form-checkbox value="Other">
          <div class="d-flex">
            <div ref="label__interested-micro-credential-other" class="mr-u4">Other</div>

            <div>
              <b-form-input
                ref="interestedMicroCredentialOther"
                v-model="interestedMicroCredentialOther"
                :state="$v.interestedMicroCredentialOther.$anyError ? false : null"
                :disabled="form.interested_micro_credentials.includes('Other') ? false : true"
                @click.stop=""
              />

              <b-form-invalid-feedback
                v-if="!$v.interestedMicroCredentialOther.required"
                id="interestedMicroCredentialOther-invalid-feedback"
              >
                Please tell us what microcredentials you are interested.
              </b-form-invalid-feedback>
            </div>
          </div>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </div>

    <slot name="afterForm" :save="save" />
  </div>
</template>

<script>
import { requiredIf, numeric } from 'vuelidate/lib/validators';
import BaseDatePicker from '@/components/base-components/BaseDatePicker.vue';
import * as PROFILE_OPTIONS from '@/assets/user-profile-template.json';
import * as PROFILE_ORIGINAL_OPTIONS from '@/assets/user-profile-template-original.json';

export default {
  components: {
    BaseDatePicker
  },

  props: {
    show: {
      type: Object,
      default: () => ({
        name: true,
        surname: true,
        dateOfBirth: false,
        phoneNumber: true,
        currentOccupation: true,
        desiredOccupation: true,
        areaOfEmployment: true,
        experienceLevel: true,
        educationLevel: true,
        goals: true,
        likeToLearn: true,
        knowUsFrom: true,
        interests: true,
        age: true,
        country: true,
        company: true,
        email: true
      })
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        firstname: null,
        lastname: null,
        date_of_birth: null,
        phone_number: null,
        current_occupation: null,
        desired_occupation: null,
        area_of_employment: null,
        experience_level: null,
        education_level: null,
        goals: [],
        like_to_learn: [],
        know_us_from: [],
        interested_micro_credentials: [],
        age: null,
        country: null,
        company: null,
        email: String
      })
    }
  },

  data() {
    return {
      form: {
        firstname: null,
        lastname: null,
        date_of_birth: null,
        phone_number: null,
        current_occupation: null,
        desired_occupation: null,
        area_of_employment: null,
        experience_level: null,
        education_level: null,
        goals: [],
        like_to_learn: [],
        know_us_from: [],
        interested_micro_credentials: [],
        age: null,
        country: null,
        company: null
      },
      educationLevelOther: '',
      knowUsFromOther: '',
      interestedMicroCredentialOther: '',
      currentOccupationOther: '',
      desiredOccupationOther: ''
    };
  },

  validations() {
    return {
      form: {
        phone_number: {
          numeric,
          length: (value) => {
            return value ? value.length === 10 : true;
          }
        }
      },
      educationLevelOther: {
        required: requiredIf(() => {
          return this.form.education_level === 'Other';
        })
      },
      knowUsFromOther: {
        required: requiredIf(() => {
          return this.form.know_us_from.includes('Other');
        })
      },
      interestedMicroCredentialOther: {
        required: requiredIf(() => {
          return this.form.interested_micro_credentials.includes('Other');
        })
      },
      currentOccupationOther: {
        required: requiredIf(() => {
          return this.form.current_occupation === 'Other';
        })
      },
      desiredOccupationOther: {
        required: requiredIf(() => {
          return this.form.desired_occupation === 'Other';
        })
      }
    };
  },

  computed: {
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = 1900;

      return Array.from({ length: currentYear - startYear + 1 }, (_, i) => currentYear - i);
    },

    currentOccupations() {
      return PROFILE_OPTIONS.aboutYouFields.fields.currentOccupation.options;
    },

    desiredOccupations() {
      return PROFILE_OPTIONS.aboutYouFields.fields.desiredOccupation.options;
    },
    employmentAreas() {
      return PROFILE_OPTIONS.aboutYouFields.fields.employmentArea.options;
    },
    experienceLevels() {
      return PROFILE_OPTIONS.aboutYouFields.fields.experienceLevel.options;
    },
    countryOptions() {
      return PROFILE_ORIGINAL_OPTIONS.aboutYouFields.fields.country.options;
    },
    ageOptions() {
      return PROFILE_ORIGINAL_OPTIONS.aboutYouFields.fields.age.options;
    }
  },

  watch: {
    educationLevelOther(value) {
      if (value) {
        console.log('yoh');
        this.$set(this.form, 'education_level', 'Other');
      }
    },

    knowUsFromOther(value) {
      if (value) {
        const otherIndex = this.form.know_us_from.findIndex((str) => str === 'Other');
        if (otherIndex === -1) {
          this.$set(this.form, 'know_us_from', [...this.form.know_us_from, 'Other']);
        }
      }
    },

    interestedMicroCredentialOther(value) {
      if (value) {
        const otherIndex = this.form.interested_micro_credentials.findIndex(
          (str) => str === 'Other'
        );
        if (otherIndex === -1) {
          this.$set(this.form, 'interested_micro_credentials', [
            ...this.form.interested_micro_credentials,
            'Other'
          ]);
        }
      }
    },
    currentOccupationOther(value) {
      if (value) {
        this.$set(this.form, 'current_occupation', 'Other');
      }
    },
    desiredOccupationOther(value) {
      if (value) {
        this.$set(this.form, 'desired_occupation', 'Other');
      }
    }
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      const {
        firstname,
        lastname,
        date_of_birth,
        phone_number,
        current_occupation,
        desired_occupation,
        area_of_employment,
        experience_level,
        // education_level,
        goals,
        like_to_learn,
        know_us_from,
        interested_micro_credentials,
        age,
        country,
        company
      } = this.data;
      this.form = {
        firstname,
        lastname,
        date_of_birth,
        phone_number,
        current_occupation,
        desired_occupation,
        area_of_employment,
        experience_level,
        education_level: null,
        goals: goals ? goals : [],
        like_to_learn: like_to_learn ? like_to_learn : [],
        know_us_from: [],
        interested_micro_credentials: [],
        age,
        country,
        company
      };
      // if (education_level.includes('Other')) {
      //   this.educationLevelOther = education_level.split('|')[1];
      //   this.$set(this.form, 'education_level', 'Other');
      // } else {
      //   this.$set(this.form, 'education_level', education_level);
      // }
      if (know_us_from && know_us_from.length) {
        const otherIndex = know_us_from.findIndex((str) => str.includes('Other'));
        if (otherIndex !== -1) {
          this.$set(this.form, 'know_us_from', [...know_us_from]);
          this.knowUsFromOther = know_us_from[otherIndex].split('|')[1];
          this.$set(this.form.know_us_from, otherIndex, 'Other');
        } else {
          this.$set(this.form, 'know_us_from', know_us_from);
        }
      }
      if (interested_micro_credentials && interested_micro_credentials.length) {
        const otherIndex = interested_micro_credentials.findIndex((str) => str.includes('Other'));
        if (otherIndex !== -1) {
          this.$set(this.form, 'interested_micro_credentials', [...interested_micro_credentials]);
          this.interestedMicroCredentialOther =
            interested_micro_credentials[otherIndex].split('|')[1];
          this.$set(this.form.interested_micro_credentials, otherIndex, 'Other');
        } else {
          this.$set(this.form, 'interested_micro_credentials', interested_micro_credentials);
        }
      }
      if (current_occupation && current_occupation.includes('Other')) {
        this.currentOccupationOther = current_occupation.split('|')[1];
        this.$set(this.form, 'current_occupation', 'Other');
      } else {
        this.$set(this.form, 'current_occupation', current_occupation);
      }
      if (desired_occupation && desired_occupation.includes('Other')) {
        this.desiredOccupationOther = desired_occupation.split('|')[1];
        this.$set(this.form, 'desired_occupation', 'Other');
      } else {
        this.$set(this.form, 'desired_occupation', desired_occupation);
      }
    },

    save(verify = false) {
      this.$v.$touch();

      if (verify && this.$v.$invalid) {
        const checkedInputs = [
          'educationLevelOther',
          'knowUsFromOther',
          'interestedMicroCredentialOther',
          'currentOccupationOther',
          'desiredOccupationOther'
        ];

        for (let index = 0; index < checkedInputs.length; index++) {
          const checkedInput = checkedInputs[index];

          if (this.$v[checkedInput].$invalid && this.$refs[checkedInput]) {
            this.$refs[checkedInput].focus();

            this.$toast.open({
              message: "'Other' options have selected, please fill the information",
              type: 'error',
              pauseOnHover: true,
              duration: 5000
            });

            break;
          }
        }
        if (this.$v['form']['phone_number'].$invalid) {
          let toastMessage = '';
          this.$refs['input__phone-number'].focus();
          if (!this.$v['form']['phone_number'].numeric) {
            toastMessage = 'Mobile phone number is invalid.';
          } else if (!this.$v['form']['phone_number'].length) {
            toastMessage = 'Mobile phone number should be 10 digits.';
          } else {
            toastMessage = 'Mobile phone number is invalid.';
          }
          this.$toast.open({
            message: toastMessage,
            type: 'error',
            pauseOnHover: true,
            duration: 5000
          });
        }

        return;
      } else {
        this.$v.$reset();
      }

      const payload = {
        ...this.form
      };

      if (payload.education_level === 'Other' && this.educationLevelOther.length) {
        this.$set(payload, 'education_level', `Other|${this.educationLevelOther}`);
      }

      if (payload.know_us_from.length) {
        const otherIndex = payload.know_us_from.findIndex((str) => str.includes('Other'));
        if (otherIndex !== -1 && this.knowUsFromOther.length) {
          this.$set(payload.know_us_from, otherIndex, `Other|${this.knowUsFromOther}`);
        }
      }

      if (payload.interested_micro_credentials.length) {
        const otherIndex = payload.interested_micro_credentials.findIndex((str) =>
          str.includes('Other')
        );
        if (otherIndex !== -1 && this.interestedMicroCredentialOther.length) {
          this.$set(
            payload.interested_micro_credentials,
            otherIndex,
            `Other|${this.interestedMicroCredentialOther}`
          );
        }
      }

      if (payload.current_occupation === 'Other' && this.currentOccupationOther.length) {
        this.$set(payload, 'current_occupation', `Other|${this.currentOccupationOther}`);
      }

      if (payload.desired_occupation === 'Other' && this.desiredOccupationOther.length) {
        this.$set(payload, 'desired_occupation', `Other|${this.desiredOccupationOther}`);
      }

      this.$emit('completed', payload);
    }
  }
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
